export default {"src":"/_next/static/media/tag.84694eaf.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};